<template>
  <div class="card shadow">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'categories' }">Categories</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Category
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body" v-loading="loading">
      <el-tabs v-model="activePane" @tab-click="tabChange">
        <el-tab-pane label="Details" name="details">
          <category-item-detail v-if="category" :category="category"/>
        </el-tab-pane>
        <el-tab-pane label="Associated Products" name="related">
          <category-item-association v-if="category" :products="products"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CategoryItemDetail from '@/components/Category/Item/CategoryItemDetail'
import CategoryItemAssociation from '@/components/Category/Item/CategoryItemAssociation'

export default {
  components: {
    CategoryItemDetail,
    CategoryItemAssociation,
  },

  data() {
    return {
      loading: false,
      activePane: 'details',
      category: null,
      products: [],
    }
  },

  async mounted() {
    this.loading = true

    try {
      var { data } = await this.$http.get(`/categories/${ this.$route.params.id }`, {
        params: { include_products: true }
      })
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }

    this.category = data.category
    this.products = data.products
  },

  methods: {
    tabChange(tab, event) {
      this.activePane = tab.name
    },
  },
}
</script>
